var EquipmentsTypeComponentModule = /** @class */ (function () {
    function EquipmentsTypeComponentModule() {
    }
    return EquipmentsTypeComponentModule;
}());
export { EquipmentsTypeComponentModule };
